import React, { useState } from 'react';
import styles from './ContactButton.module.css';
import contact from './contact.png';
import { contactNumber, contactEmail } from '../../config/variables';

const ContactButton = () => {
  const [expanded, setExpanded] = useState(false);

  const handleClick = () => {
    setExpanded(!expanded);
  };

  return (
    <div className={`${styles.square} ${expanded ? styles.expanded : ''}`} onClick={handleClick}>
      {expanded ? (
        <>
          <div className={`${styles.text} ${styles.expandedText}`}>Contact: {contactNumber} | {contactEmail}</div>
          <img src={contact} className={`${styles.icon} ${styles.expandedIcon}`} />
        </>
      ) : (
        <img src={contact} className={styles.icon} />
      )}
    </div>
  );
};

export default ContactButton;



